import { useQuery } from "@tanstack/react-query";
import SupportArticleButton from "components/Atoms/SupportArticleButton";
import { Loading } from "components/panels";
import PanelSegmentType from "components/panels/PanelSegment/PanelSegment";
import React from "react";

interface SupportArticlePanelProps {
  config: server.dto.ArticlePanelConfig
}

const SupportArticlePanel = (props: SupportArticlePanelProps) => {
  if (!props.config.displayPanel) {
    return null;
  }

  const articlesApi = useQuery({
    queryKey: ["supportArticles", props.config.topic],
    queryFn: async () => window.CoreApi.Article.SupportByTopic(props.config.topic).then(r => r.data.data)
  });

  if (articlesApi.data?.length === 0) {
    return null;
  }

  return (
    <div className="support-article-panel-wrapper s1_related-feature-panel">

      <PanelSegmentType.Header size="h2">
        <PanelSegmentType.Title title={props.config.headerLabel} />
      </PanelSegmentType.Header>

      {articlesApi.isLoading && <Loading />}
      {!articlesApi.isLoading && articlesApi.data && articlesApi.data.length > 0 && (
        <div>
          {articlesApi.data.map((article, index) => (
            <SupportArticleButton key={index} articleId={article.articleId} label={article.title} />
          ))}
        </div>
      )}
    </div>
  );
};

export default SupportArticlePanel;
